import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MessagesSquare, Trash2, VolumeX, Timer, Flag } from "lucide-react";
import { api } from "@/lib/api";
import { Panel } from "@/components/Peep";

const TOOLS = [
  { icon: Trash2, text: "Delete any message — tap and hold (or hover) a message, then choose Delete." },
  { icon: VolumeX, text: "Mute a viewer from the same message menu to hide their messages from your view." },
  { icon: Timer, text: "Slow mode limits each viewer to one message every 30 seconds." },
  { icon: Flag, text: "Viewers can report a stream; reports go to the PEEPING team." },
];

export default function LiveChatHub() {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    api.get("/creator/live/sessions").then((r) => setRows((r.data.sessions || []).filter((s) => s.status !== "ended"))).catch(() => setRows([]));
  }, []);
  return (
    <div data-testid="creator-live-chat" className="flex flex-col gap-6">
      <div>
        <h1 className="text-3xl font-extrabold">Live chat & moderation</h1>
        <p className="mt-1 text-sm text-[#a7a0af]">Chat runs alongside each broadcast. Open a session's studio to read and moderate its chat in real time.</p>
      </div>
      <Panel title="Your sessions">
        {!rows ? <p className="text-sm text-[#a7a0af]">Loading…</p> : rows.length === 0 ? (
          <p data-testid="live-chat-empty" className="text-sm text-[#a7a0af]">No open sessions. <Link to="/creator/live" className="text-[#f0a8fa] underline">Go Live</Link> to start one — its chat opens automatically.</p>
        ) : (
          <ul className="flex flex-col gap-2">
            {rows.map((s) => (
              <li key={s.id} className="flex items-center justify-between gap-3 rounded-xl border border-white/10 p-3">
                <span className="min-w-0"><span className="block truncate text-sm font-semibold">{s.title}</span><span className="text-[0.65rem] uppercase text-[#a7a0af]">{s.status}</span></span>
                <Link to={`/creator/live/${s.id}/studio`} data-testid={`live-chat-open-${s.id}`} className="flex shrink-0 items-center gap-1 rounded-lg border border-[#d42be8]/50 bg-[#d42be8]/10 px-3 py-2 text-xs font-semibold text-[#f0a8fa]"><MessagesSquare size={13} /> Open chat</Link>
              </li>
            ))}
          </ul>
        )}
      </Panel>
      <Panel title="Moderation tools">
        <ul className="flex flex-col gap-3">
          {TOOLS.map(({ icon: Icon, text }) => <li key={text} className="flex items-start gap-3 text-sm text-[#c7c1cf]"><Icon size={16} className="mt-0.5 shrink-0 text-[#c77dff]" /> {text}</li>)}
        </ul>
      </Panel>
    </div>
  );
}
